import { motion } from "framer-motion";
import { ArrowUpRight, Bike } from "lucide-react";
import Reveal from "./Reveal";
import { DELIVERY_LINKS } from "@/data/content";

const PLATFORMS = [
  { name: "DoorDash", tag: "Fast Delivery", href: DELIVERY_LINKS.doordash, color: "#EF2A39" },
  { name: "Uber Eats", tag: "At Your Door", href: DELIVERY_LINKS.ubereats, color: "#06C167" },
];

export default function Delivery() {
  return (
    <section id="order" data-testid="delivery-section" className="relative bg-[#0D0D0D] py-24 md:py-32 px-6 md:px-10 border-t border-[#C8A24A]/10">
      <div className="mx-auto max-w-[1400px]">
        <Reveal className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-[#C8A24A] uppercase text-xs tracking-[0.35em] mb-4">
            <Bike className="h-4 w-4" /> Order Online
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl">
            Ekaa, <span className="italic text-gold-gradient">Delivered</span>
          </h2>
          <p className="mt-5 text-[#D6D6D6] font-light max-w-xl mx-auto text-sm md:text-base">
            Craving our tandoor specialties at home? Order through your favorite platform
            and we&apos;ll bring the luxury to your doorstep.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {PLATFORMS.map((p, i) => (
            <motion.a
              key={p.name}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              data-testid={`delivery-${p.name.toLowerCase().replace(" ", "-")}`}
              className="hover-gold-glow group relative bg-[#181818] border border-[#C8A24A]/15 rounded-sm p-9 flex items-center justify-between overflow-hidden"
            >
              <span className="absolute left-0 top-0 h-full w-1" style={{ backgroundColor: p.color }} />
              <div>
                <p className="text-[#C8A24A] text-[10px] tracking-[0.3em] uppercase mb-2">{p.tag}</p>
                <p className="font-display text-3xl md:text-4xl text-white group-hover:text-gold-gradient transition-all">{p.name}</p>
              </div>
              <span className="h-14 w-14 flex items-center justify-center border border-[#C8A24A]/40 rounded-full text-[#C8A24A] group-hover:bg-[#C8A24A] group-hover:text-[#0D0D0D] transition-all">
                <ArrowUpRight className="h-6 w-6" />
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
